import { render, staticRenderFns } from "./LessonDetailItem.vue?vue&type=template&id=2c136e49&scoped=true"
import script from "./LessonDetailItem.vue?vue&type=script&lang=js"
export * from "./LessonDetailItem.vue?vue&type=script&lang=js"
import style0 from "./LessonDetailItem.vue?vue&type=style&index=0&id=2c136e49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c136e49",
  null
  
)

export default component.exports